import React, {useRef} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {Toast} from "primereact/toast";
import {webInfo} from "../../../../utils/webInfo";
import {Button} from "primereact/button";
import {Link} from "react-router-dom";
import useDelete from "../../../../hooks/useDelete";
import callToast, {catchError} from "../../../../utils/helper";
import {Skeleton} from "primereact/skeleton";
import {InputSwitch} from "primereact/inputswitch";
import usePost from "../../../../hooks/usePost";

const CropTable = ({ products, total, onPageChange, page, perPage, update, setUpdate }: any) => {
    // const navigate = useNavigate();
    const { remove, loading: rloading } = useDelete();
    const {post, loading: ploading} = usePost()
    const toast = useRef<any>(null);

    const imageBodyTemplate = (rowData: any) => (
        <img
            src={`${webInfo.baseUrl}/${rowData.thumbnail_image}`}
            alt={rowData.name}
            style={{ width: "30px", height: "30px", borderRadius: "6px", objectFit: 'cover' }}
        />
    );

    const divisionBodyTemplate = () => <span>Chemist Crop Care</span>;

    const pdfBodyTemplate = (rowData: any) => {
        if (!rowData.details_pdf) return <span className="text-red-600">No File</span>;
        return (
            <a href={`${webInfo.baseUrl}/${rowData.details_pdf}`} target="_blank" rel="noopener noreferrer">
                <Button outlined label="View PDF" icon="pi pi-file-pdf" className="p-button-sm" />
            </a>
        );
    };

    const brandBodyTemplate = (rowData: any) => {
        const div = `products-crop`;
        const link = `/products/${rowData.id}?url=${div}&division=11`;
        return (
            <div>
                <Link className="text-gray-900 underline" style={{ cursor: "pointer" }} to={link}>
                    {rowData?.brand_name}
                </Link>
            </div>
        );
    };

    // Delete logic
    const removeProduct = async (id: any) => {
        const deleteUrl = `${webInfo.baseUrl}/api/admin/products-crop/${id}`;
        try {
            const res: any = await remove(deleteUrl);
            if (res.success) {
                callToast(toast, true, "Product deleted successfully");
                setUpdate(!update);
            } else {
                callToast(toast, false, res.error.message);
            }
        } catch (e) {
            catchError(e);
        }
    };

    const confirmRemoveProduct = (id: any) => {
        confirmDialog({
            message: "Are you sure you want to delete this product?",
            header: "Delete Confirmation",
            icon: "pi pi-exclamation-triangle",
            acceptClassName: "p-button-danger",
            accept: () => removeProduct(id),
        });
    };

    const actionBodyTemplate = (rowData: any) => (
        <div className="flex gap-2">
            {/*<Button*/}
            {/*    icon="pi pi-eye"*/}
            {/*    label="Details"*/}
            {/*    className="p-button-sm"*/}
            {/*    onClick={() => navigate(`/products/${rowData.id}?url=products-crop&division=11`)}*/}
            {/*/>*/}
            <Button
                icon="pi pi-trash"
                title="Remove"
                className="p-button-sm p-button-danger"
                onClick={() => confirmRemoveProduct(rowData.id)}
                loading={rloading}
            />
        </div>
    );

    const publishStatus = (rowData: any) => {
        const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/products-crop/${rowData?.id}/publish-status`
        const updateStatus = async (rowData: any) => {
            const payload = {
                status: Number(rowData.status) === 1 ? 0 : 1,
            }
            try {
                const res: any = await post(statusUpdateUrl, true, payload)
                if (res.success) {
                    setUpdate(!update);
                }
            } catch (e) {
                catchError(e)
            }
        }

        if (ploading) {
            return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
        }
        return <div className="flex gap-2 justify-content-start">
            <InputSwitch checked={Number(rowData?.status) === 1} onChange={() => updateStatus(rowData)}/>
        </div>
    }

    return (
        <div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <DataTable value={products}>
                <Column header="Image" body={imageBodyTemplate} />
                <Column body={brandBodyTemplate} header="Brand" />
                <Column field="product_name" header="Product Name" />
                <Column header="Division" body={divisionBodyTemplate} />
                <Column body={publishStatus} header="Publish Status" sortable/>
                <Column header="PDF" body={pdfBodyTemplate} />
                <Column header="Actions" body={actionBodyTemplate} />
            </DataTable>

            <Paginator
                first={(page - 1) * perPage}
                rows={perPage}
                totalRecords={total}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default CropTable;